import { jsonProperty, Serializable } from 'ts-serializable';

import { SurveyAnswerModel } from '~modules/surveys/models/SurveyAnswerModel';
import { SurveyExtraQuestionModel } from '~modules/surveys/models/SurveyExtraQuestionModel';
import { SurveyAnswerTypeIdEnum } from '~modules/surveys/types/SurveyAnswerTypeIdEnum';

// Вопрос в не пройденном опросе
export class SurveyQuestionModel extends Serializable {
  @jsonProperty(Number, null) questionId: number | null = null;
  @jsonProperty(Number, null) answerTypeId: SurveyAnswerTypeIdEnum | null = null;
  @jsonProperty(String, null) descr: string | null = null;
  @jsonProperty(String, null) notes: string | null = null;
  @jsonProperty(Number, null) answerId: number | null = null;
  @jsonProperty(Number, null) happyIndex: number | null = null;
  @jsonProperty(String, null) textValue: string | null = null;
  @jsonProperty([SurveyAnswerModel]) answers: SurveyAnswerModel[] = [];
  @jsonProperty([SurveyExtraQuestionModel]) extraQuestions: SurveyExtraQuestionModel[] = [];
}
